import React from "react";

import { LANDING_MENU_BAR } from "./../../constants/strings/StringsDashboard";

import "./citizenPerception.css";

import FilterComponent from "../../CitizenPerception/components/FilterPerceptionComponent";
import Form, { formTypes } from "../../Forms/Containers/FormCreator";

function CitizenPerceptionComponent(props) {
  return (
    <>
      <div>
        <h1 className="page-title">
          {LANDING_MENU_BAR.PERCEPTION}
        </h1>
        <div className="content-landing"></div>
      </div>
      <div className="line line-100">
        <Form
          onChange={props.formChange}
          objectCreator={[
            {
              type: formTypes.div,
              classContainer: "line line-5",
            },
            {
              type: formTypes.select,
              // label: "Tipo",
              placeholder: "Seleccione el tipo de clasificación",
              required: false,
              classContainer: "line line-30",
              classLabel: "input-text",
              // classInput: "form-control",
              variable: "percepcionCitizen",
              keyValue: "value",
              keyText: "text",
              data: [
                { value: "PERCEPCIÓN", text: "Percepción" },
                { value: "CALIFICACIÓN", text: "Calificación" },
                { value: "VICTIMIZACIÓN", text: "Victimización" },
                { value: "LÍNEA 123", text: "Línea 123" },
                {
                  value: "GEOGRÁFICO",
                  text: "Georreferenciación",
                },
                { value: "HURTOS", text: "Hurtos" },
              ],
              value: [],
            },
            {
              type: formTypes.div,
              classContainer: "line line-5",
            },
            {
              type: formTypes.div,
              classContainer: "line line-60",
            },
          ]}
        />
        <FilterComponent onChange={props.filterChange} />
      </div>
    </>
  );
}

export default CitizenPerceptionComponent;
